import { Component, Input, ViewEncapsulation } from '@angular/core';
import { SearchQuery } from 'components/accordion/search-widget/model/search-query.model';

@Component({
  selector: 'app-search-widget',
  templateUrl: './search-widget.component.html',
  styleUrls: ['./search-widget.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SearchWidgetComponent {
  @Input()
  isHybrid: boolean;
  public search: SearchQuery;
  public resultsVisible;

  constructor() {
    this.search = {
      query: null,
      results: [],
      isSearching: false,
      hasResults: false
    };
    this.resultsVisible = false;
  }
}
